import React from 'react'

import DdayBanner from '../components/DdayBanner'
import GoalOfDays from '../components/GoalOfDays'
import GroupRecommendedBooks from '../components/GroupRecommendedBooks'
import MyPageLayout from '../components/myPageLayout'
import StudyingReport from '../components/StudyingReport'
import { useBookcafeData, useMyPage } from '../module/myPage/hook'
import { useUserSurvey } from '../module/sconnStudyData/hook'

export default function MyPageMain() {
  const { user } = useBookcafeData()
  const { surveyParticipated } = useMyPage()
  const {
    error: surveyError,
    isError: surveyIsError,
    isPending: surveyIsPending,
  } = useUserSurvey()

  return (
    <MyPageLayout user={user}>
      <MyPageLayout.AccountNavigation user={user} />
      <MyPageLayout.Content
        surveyErrorMessage={surveyError?.message}
        surveyIsError={surveyIsError}
        surveyParticipated={surveyParticipated}
        surveyIsPending={surveyIsPending}
      >
        <DdayBanner />
        <GoalOfDays />
        <StudyingReport />
        <GroupRecommendedBooks />
      </MyPageLayout.Content>
    </MyPageLayout>
  )
}
